import React, {
  useState,
  useCallback,
  ForwardRefRenderFunction,
  useImperativeHandle,
  forwardRef,
} from "react";
import axios from "axios";
import { InputText } from "./components/fields/InputText";
import { fieldsInterface } from "./FormModel";
import { toastfy } from "../toast/Toast";
import { getAuth } from "../../../app/modules/auth";
import { showErrorMessage } from "../../helpers/MessagesHelper";
import { useFormik } from "formik";
import { getIn } from "formik";
import clsx from "clsx";
import InputMask from "react-input-mask";
import { useStyleContext } from "../../helpers/StyleContext";
import PhoneNumberInput from "./components/fields/InputCelphone";
import { Button, Modal } from "react-bootstrap";
import { ScannerQR } from "../../layout/components/ScannerQR/ScannerQR";
import WebCamPicture from "../../layout/components/WebCamPicture/WebCamPicture";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

type Props = {
  fields: fieldsInterface[];
  nameModule?: string;
  module: string;
  descriptionModule?: string;
  operation?: string;
  validationSchema?: Object;
  validationInitialValues?: any;
  hasSigners?: boolean;
  closeModal?: () => void;
  onSuccess?: (data: any) => void;
  handleIsLoading: (isLoading: boolean) => void;
  currentStep?: number;
};

export interface FormHandles {
  handleClearFormikAndPicture: () => void;
  handleSubmit: () => void;
  validateForm: () => Promise<any>;
  setTouched: (touched: any) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  getValues: () => any;
  isLoading: boolean;
}

const FormVisitor: ForwardRefRenderFunction<FormHandles, Props> = (
  {
    fields,
    nameModule,
    module,
    descriptionModule,
    validationSchema,
    operation = "",
    validationInitialValues,
    closeModal,
    onSuccess,
    handleIsLoading,
    currentStep,
  },
  ref,
) => {
  const { styleState } = useStyleContext();
  const navigate = useNavigate();

  const apiToken = getAuth();
  const token = apiToken?.api_token;
  const [content] = useState<string>("");
  const [viewModal, setModal] = useState(false);
  const [cameraOn, setCameraOn] = useState(true);
  const [clearPicture, setClearPicture] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);

  const headers = {
    Authorization: `Bearer ${token}`,
    operation: operation,
  };

  const qrCodeScan = async (contentScan: any) => {
    const qrValue =
      typeof contentScan === "string"
        ? contentScan
        : contentScan?.text || contentScan?.data || "";

    if (!qrValue || String(qrValue).trim() === "") {
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const res = await axios.get(
        `${apiUrl}/bracelets/check-qrcode?qrcode=${encodeURIComponent(
          qrValue,
        )}`,
        { headers },
      );

      if (res.data) {
        if (res.data.id_user || res.data._id_user || res.data._id_usuario) {
          toastfy("error", "Este QR Code já está atribuído a outro usuário!");
          return;
        }

        if (
          res.data.status &&
          res.data.status !== "ACTIVE" &&
          res.data.status !== 1
        ) {
          toastfy("error", "Este QR Code está inativo no sistema!");
          return;
        }
      }

      formik.setFieldValue("content", qrValue);
      setCameraOn(false);
      setModal(false);
      toastfy("success", "QR Code lido e validado com sucesso!");
    } catch (error) {
      toastfy("error", "QR Code inválido ou não cadastrado na base.");
    }
  };

  const handleIsDisabled = useCallback(
    (bol: boolean) => {
      setIsButtonDisabled(bol);
      handleIsLoading(bol);
    },
    [handleIsLoading, setIsButtonDisabled],
  );

  const formik = useFormik({
    initialValues: validationInitialValues,
    validationSchema: validationSchema,
    enableReinitialize: true,

    onSubmit: async (values) => {
      handleIsDisabled(true);

      const apiUrl = process.env.REACT_APP_API_URL;

      try {
        let hasError = false;

        if (values.email) {
          const resEmail = await axios.get(
            `${apiUrl}/users/find/email?email=${values.email}`,
            { headers },
          );
          if (resEmail.data === true || String(resEmail.data) === "true") {
            formik.setFieldError("email", "Este e-mail já está em uso.");
            hasError = true;
          }
        }

        if (hasError) {
          toastfy("error", "Verifique os erros no formulário antes de salvar.");
          handleIsDisabled(false);
          return;
        }
      } catch (error) {
        // Ignora erro de rede e tenta salvar
      }

      const inputsCheckbox = document.querySelectorAll("input[type=checkbox]");

      const formatFields = (fields: fieldsInterface[], body: any) => {
        const formatted = { ...body };
        fields.forEach((field) => {
          if (field.field.type === "number" && body[field.reference]) {
            formatted[field.reference] = Number(body[field.reference]);
          }
        });
        return formatted;
      };

      const mapCheckboxElements = Array.from(inputsCheckbox).map((element) => {
        const checkboxElement = element as HTMLInputElement;
        return { [checkboxElement.name]: checkboxElement.checked };
      });

      const formattedCheckboxElements = mapCheckboxElements?.reduce(
        (acc, obj) => ({ ...acc, ...obj }),
        {},
      );

      // 🟢 BLINDAGEM: Garante que a imagem está formatada como string (Base64), senão envia string vazia
      const profileImg =
        typeof formik.values.profile_image === "string"
          ? formik.values.profile_image
          : "";

      const formattedBody = {
        ...formatFields(fields, values),
        ...formattedCheckboxElements,
        profile_image: profileImg,
      };

      axios
        .post(`${apiUrl}/${module}`, formattedBody, { headers })
        .then((response) => {
          handleIsDisabled(false);
          toastfy("success", "Operação bem sucedida!");

          handleClearFormikAndPicture();

          if (onSuccess) {
            onSuccess(response.data);
          } else if (closeModal) {
            closeModal();
          }
        })
        .catch((error) => {
          const errorResponse = error.response?.data;

          if (
            errorResponse?.error === "LEGACY_DEBTOR_DETECTED" ||
            errorResponse?.message === "LEGACY_DEBTOR_DETECTED"
          ) {
            handleIsDisabled(false);

            Swal.fire({
              title: "Atenção: Cliente Devedor!",
              text: "Este CPF consta como devedor antigo. Deseja visualizar o cadastro?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Sim, visualizar",
              cancelButtonText: "Cancelar",
            }).then((result) => {
              if (result.isConfirmed) {
                if (closeModal) closeModal();
                const cpfSearch = values.cpf;
                navigate(`/users?search=${cpfSearch}&finddebtors=true`);
              }
            });
            return;
          }

          showErrorMessage(
            error?.response?.status,
            error?.response?.data?.error,
          );

          handleIsDisabled(false);
        });
    },
  });

  const handleBlurWithAPI = async (e: any, reference: string) => {
    formik.handleBlur(e);
    const value = e.target.value;

    if (!value || getIn(formik.errors, reference)) return;

    const apiUrl = process.env.REACT_APP_API_URL;

    try {
      if (reference === "email") {
        const res = await axios.get(
          `${apiUrl}/users/find/email?email=${value}`,
          { headers },
        );
        if (res.data === true || String(res.data) === "true") {
          formik.setFieldError("email", "Este e-mail já está em uso.");
        }
      }
    } catch (error) {}
  };

  const handleClearFormikAndPicture = useCallback(() => {
    formik.resetForm();
    setClearPicture(!clearPicture);
  }, [clearPicture, formik, setClearPicture]);

  const handleSubmit = useCallback(() => {
    formik.handleSubmit();
  }, [formik]);

  useImperativeHandle(ref, () => ({
    handleClearFormikAndPicture,
    handleSubmit,
    validateForm: () => formik.validateForm(),
    setTouched: (touched: any) => formik.setTouched(touched),
    setFieldValue: (field, value, shouldValidate) =>
      formik.setFieldValue(field, value, shouldValidate),
    getValues: () => formik.values,
    isLoading: isButtonDisabled,
  }));

  return (
    <div
      className="card"
      style={{
        backgroundColor: styleState?.secondary_color,
        color: styleState?.secondary_text_color,
      }}
    >
      {(nameModule || descriptionModule) && (
        <div className="card-header">
          <h3 className="card-title align-items-start flex-column">
            {nameModule && (
              <span
                className="card-label fw-bold fs-3 mb-1"
                style={{
                  color: styleState?.secondary_text_color,
                }}
              >
                {nameModule}
              </span>
            )}
            {descriptionModule && (
              <span
                className={clsx("mt-1 fw-semibold fs-7", {
                  "text-muted": !styleState.secondary_text_color,
                })}
                style={{
                  color: styleState?.secondary_text_color,
                }}
              >
                {descriptionModule}
              </span>
            )}
          </h3>
        </div>
      )}

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
        className="form"
      >
        <div className="d-flex flex-wrap justify-content-center align-items-center">
          {fields?.map((field: any, index) => {
            const step = field.step || 1;
            if (currentStep !== undefined && step !== currentStep) return null;

            return (
              <div
                className={`${field.colSize || "col-12 col-sm-6"} p-1`}
                key={field.description}
              >
                <label
                  className={
                    "col-lg-4 fw-bold fs-6 w-100 text-start" +
                    (field.required ? " required" : "")
                  }
                  style={{
                    color: styleState?.secondary_text_color,
                  }}
                >
                  {field.description}
                </label>
                {field.field.element === "profile_image" && (
                  <WebCamPicture
                    setClearPicture={setClearPicture}
                    clearPicture={clearPicture}
                    removeBorder={true}
                    onPictureCapture={(pic: any) => {
                      // 🟢 CONVERSÃO DE ARQUIVO FÍSICO PARA BASE64
                      if (pic instanceof File || pic instanceof Blob) {
                        const reader = new FileReader();
                        reader.readAsDataURL(pic);
                        reader.onloadend = () => {
                          formik.setFieldValue(
                            field.reference,
                            reader.result as string,
                          );
                        };
                      } else if (typeof pic === "object" && pic !== null) {
                        const base64Str =
                          pic.dataUri ||
                          pic.base64 ||
                          pic.image ||
                          pic.src ||
                          "";
                        formik.setFieldValue(field.reference, base64Str);
                      } else {
                        formik.setFieldValue(field.reference, pic || "");
                      }
                    }}
                    className={clsx(
                      "form-control d-flex justify-content-around align-items-center",
                      {
                        "is-invalid":
                          getIn(formik?.touched, field.reference) &&
                          getIn(formik?.errors, field.reference),
                      },
                      {
                        "is-valid":
                          getIn(formik?.touched, field.reference) &&
                          !getIn(formik?.errors, field.reference),
                      },
                    )}
                  />
                )}
                <div>
                  {field.field.element === "input" &&
                    (field.field.type === "text" ||
                      field.field.type === "instagram" ||
                      field.field.type === "password" ||
                      field.field.type === "email" ||
                      field.field.type === "date" ||
                      field.field.type === "number") && (
                      <InputText
                        className={
                          field.field.className ||
                          field.className ||
                          clsx(
                            "form-control form-control-sm",
                            {
                              "is-invalid":
                                getIn(formik?.touched, field.reference) &&
                                getIn(formik?.errors, field.reference),
                            },
                            {
                              "is-valid":
                                getIn(formik?.touched, field.reference) &&
                                !getIn(formik?.errors, field.reference),
                            },
                          )
                        }
                        name={field.reference}
                        id={field.field.id}
                        placeholder={field.field.placeholder}
                        value={getIn(formik?.values, field.reference) || ""}
                        handleChange={formik.handleChange}
                        onBlur={(e: any) =>
                          handleBlurWithAPI(e, field.reference)
                        }
                        type={field.field.type}
                        disabled={field.disabled || field.field.disabled}
                        readOnly={field.readOnly || field.field.readOnly}
                      />
                    )}

                  {field.field.element === "select" && (
                    <select
                      className={clsx(
                        "form-select form-select-sm",
                        {
                          "is-invalid":
                            getIn(formik?.touched, field.reference) &&
                            getIn(formik?.errors, field.reference),
                        },
                        {
                          "is-valid":
                            getIn(formik?.touched, field.reference) &&
                            !getIn(formik?.errors, field.reference),
                        },
                      )}
                      name={field.reference}
                      id={field.field.id}
                      value={getIn(formik?.values, field.reference) || ""}
                      onChange={(e) => {
                        formik.handleChange(e);
                        if (field.field.onChange) field.field.onChange(e);
                        if (field.onChange) field.onChange(e);
                      }}
                      onBlur={(e: any) => handleBlurWithAPI(e, field.reference)}
                      disabled={field.disabled || field.field.disabled}
                    >
                      <option value="" disabled hidden>
                        {field.field.placeholder || "Selecione..."}
                      </option>
                      {field.field.options?.map((opt: any) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label || opt.description}
                        </option>
                      ))}
                    </select>
                  )}

                  {field.field.element === "checkbox" && (
                    <div className="form-check form-check-custom form-check-solid mt-4">
                      <input
                        className={clsx("form-check-input", {
                          "is-invalid":
                            getIn(formik?.touched, field.reference) &&
                            getIn(formik?.errors, field.reference),
                        })}
                        type="checkbox"
                        name={field.reference}
                        id={field.reference}
                        checked={
                          getIn(formik?.values, field.reference) === true
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={field.disabled || field.field.disabled}
                      />
                      <label
                        className="form-check-label fw-bold"
                        htmlFor={field.reference}
                        style={{
                          color: styleState?.secondary_text_color,
                        }}
                      >
                        Sim
                      </label>
                    </div>
                  )}

                  {field.reference === "celphone" && (
                    <PhoneNumberInput
                      className={clsx(
                        "form-control form-control-sm",
                        {
                          "is-invalid":
                            getIn(formik?.touched, field.reference) &&
                            getIn(formik?.errors, field.reference),
                        },
                        {
                          "is-valid":
                            getIn(formik?.touched, field.reference) &&
                            !getIn(formik?.errors, field.reference),
                        },
                      )}
                      name={field.reference}
                      placeholder={field.field.placeholder}
                      value={getIn(formik?.values, field.reference) || ""}
                      onChange={(value: string) => {
                        formik.setFieldValue(field.reference, value);
                      }}
                    />
                  )}

                  {field.field.type === "cpf" && (
                    <InputMask
                      mask="999.999.999-99"
                      className={clsx(
                        "form-control form-control-sm",
                        {
                          "is-invalid":
                            getIn(formik?.touched, field.reference) &&
                            getIn(formik?.errors, field.reference),
                        },
                        {
                          "is-valid":
                            getIn(formik?.touched, field.reference) &&
                            !getIn(formik?.errors, field.reference),
                        },
                      )}
                      name={field.reference}
                      id={field.field.id}
                      placeholder={field.field.placeholder}
                      value={getIn(formik?.values, field.reference) || ""}
                      onChange={formik.handleChange}
                      onBlur={(e: any) => handleBlurWithAPI(e, field.reference)}
                      disabled={field.disabled || field.field.disabled}
                    />
                  )}

                  {field.reference === "content" && (
                    <div className="d-flex position-relative align-items-center">
                      {!(formik.values.content === content) ? (
                        <div
                          className={clsx(
                            "form-control d-flex justify-content-between align-items-center",
                            {
                              "is-invalid":
                                getIn(formik?.touched, field.reference) &&
                                getIn(formik?.errors, field.reference),
                            },
                          )}
                          onClick={() => {
                            setModal(true);
                            setCameraOn(true);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <label>QR Code Adicionado </label>
                          <div className="bg-success rounded-circle">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="currentColor"
                              className="bi bi-check text-black"
                              viewBox="0 0 16 16"
                            >
                              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                            </svg>
                          </div>
                        </div>
                      ) : (
                        <div
                          className={clsx(
                            "form-control form-control-sm d-flex justify-content-between align-items-center",
                            {
                              "is-invalid":
                                getIn(formik?.touched, field.reference) &&
                                getIn(formik?.errors, field.reference),
                            },
                          )}
                          onClick={() => {
                            setModal(true);
                            setCameraOn(true);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <label>Clique para adicionar um QR Code</label>
                          <div>
                            <i className="bi bi-upc-scan"></i>
                          </div>
                        </div>
                      )}
                      <div>
                        <Modal
                          show={viewModal}
                          centered={true}
                          contentClassName="me-1"
                          className="bg-black"
                          style={{ zIndex: 1080 }}
                        >
                          <Modal.Body>
                            <ScannerQR
                              contentScan={qrCodeScan}
                              cameraOn={cameraOn}
                            />
                          </Modal.Body>
                          <Modal.Footer className="d-flex align-items-center">
                            <Button
                              variant="secondary"
                              className="btn-sm"
                              onClick={() => {
                                setModal(false);
                                setCameraOn(false);
                              }}
                            >
                              Fechar
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </div>
                    </div>
                  )}

                  {getIn(formik.touched, field.reference) &&
                    getIn(formik.errors, field.reference) && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          <span role="alert">
                            {String(getIn(formik.errors, field.reference))}
                          </span>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            );
          })}
        </div>
      </form>
    </div>
  );
};

export default forwardRef(FormVisitor);
